import { usePropertyRentalPurchaseDate } from '../../../../queries/PropertyFields/RentalCoreFields';
import { ApplicationQuestionReviewItem } from '../../../components/ApplicationQuestionReviewItem';
import { DateTimeBox } from '@apply/components';

export interface DateOfPurchaseProps {
    propertyGuid: string;
    required?: boolean;
    isReview?: boolean;
}

export const DateOfPurchase: React.FC<DateOfPurchaseProps> = ({ propertyGuid, required, isReview = false }) => {
    const label = 'Date of Purchase';
    const [purchaseDate, set_purchaseDate] = usePropertyRentalPurchaseDate(propertyGuid);

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={purchaseDate}
                />
            ) : (
                <DateTimeBox
                    id='dateOfPurchase'
                    dataTestid='date-of-purchase'
                    required={required}
                    value={purchaseDate}
                    onChange={(value) => set_purchaseDate(value)}
                    label={label}
                />
            )}
        </>
    );
};
